export default "__VITE_ASSET__CpQ$jT89__"